import { useState, useEffect } from 'react';

export default function ReadingProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let raf = 0;
    let last = -1;

    const update = () => {
      raf = 0;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? Math.min((window.scrollY / docHeight) * 100, 100) : 0;
      // Round to 0.5% steps so we only re-render on a visible change.
      const stepped = Math.round(pct * 2) / 2;
      if (stepped !== last) {
        last = stepped;
        setProgress(stepped);
      }
    };

    // Coalesce many scroll events into one update per animation frame.
    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div className="fixed top-0 left-0 right-0 z-[99] h-[3px] bg-transparent pointer-events-none">
      <div
        className="h-full bg-gradient-to-r from-electric via-[#00cfff] to-[#00ff9d] transition-all duration-100 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}
